'use client';

import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../../firebaseConfig';
import Post from '../../Post';
import Spacing from '../../Spacing';
import SectionHeading from '../../SectionHeading';

export default function BlogSectionStyle3({
  sectionTitle,
  sectionTitleUp,
  sectionTitleDown,
  sectionSubTitle,
}) {
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const q = query(collection(db, 'blogs'), orderBy('publishAt', 'desc'));
        const querySnapshot = await getDocs(q);

        const posts = querySnapshot.docs.map((doc) => {
          const data = doc.data();

          return {
            title: data.title || 'Untitled Post',
            thumbUrl: data.image || '/images/FREEDOM.jpg',
            date: data.publishAt || 'Coming Soon',
            href: `/blog/${doc.id}`,
            btnText: 'Read More',
            socialShare: false,
            variant: 'cs_type_1',
          };
        });

        /* setBlogPosts(posts); */
        setBlogPosts(posts.slice(0, 3));
      } catch (error) {
        console.error('Error fetching blog posts:', error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div className="container">
      <SectionHeading
        title={sectionTitle}
        titleUp={sectionTitleUp}
        titleDown={sectionTitleDown}
        subTitle={sectionSubTitle}
        center
      />
      <Spacing md="72" lg="50" />
      <div className="row cs_gap_y_24">
        {blogPosts.map((item, index) => (
          <div className="col-lg-4" key={index}>
            <Post {...item} />
          </div>
        ))}
      </div>
    </div>
  );
}
